{
  "hero": {
    "title": "Terms of Use",
    "description": "The basic rules for using a NAPAICP account. An individual competition may publish additional rules of its own; those take precedence for that competition."
  },
  "quickNav": {
    "label": "On this page",
    "account": "Account use",
    "conduct": "Conduct",
    "content": "Submissions & content",
    "availability": "Service availability",
    "changes": "Changes to these terms",
    "related": "Related pages"
  },
  "account": {
    "heading": "Account use",
    "items": {
      "accurate": "Your name, email, and organization at registration must be accurate and your own; do not register under someone else's identity.",
      "credentials": "You are responsible for keeping your password secure. Platform administrators cannot read or set a user's permanent password.",
      "oneAccount": "Each person should use a single account to take part in competitions on the platform. Using multiple accounts to circumvent competition rules (e.g. team-size limits) violates these terms."
    }
  },
  "conduct": {
    "heading": "Conduct",
    "description": "While using the platform, you must not:",
    "items": {
      "impersonate": "Impersonate another person, or fabricate registration or judging data",
      "unauthorized": "Attempt to bypass access controls to reach a competition, submission, or score that is not yours",
      "abuse": "Use automated means to repeatedly attempt sign-in, abuse invitation links, or otherwise disrupt normal operation",
      "share": "Download, forward, or publicly share another participant's non-public submission without authorization",
      "shuttle": "When booking an event shuttle, booking under a false name, forwarding or selling a ride QR, or using several email addresses to evade the one-booking-per-person-per-day-per-direction limit"
    }
  },
  "content": {
    "heading": "Submissions & content",
    "description": "Ownership and usage rights for submitted work are described in the \"Work ownership\" section of the Data Policy page. Everything you submit (registration data, files, and form answers) must be something you are legally entitled to submit, and must not infringe a third party's rights."
  },
  "availability": {
    "heading": "Service availability",
    "description": "We take reasonable measures to keep the service stable, but do not guarantee uninterrupted availability. If a major platform outage happens before a submission deadline, an administrator may extend that competition's deadline through an audited procedure; see the Trust Center."
  },
  "changes": {
    "heading": "Changes to these terms",
    "description": "These terms may be updated as the platform evolves. Material changes will be announced on this page. Continuing to use the platform means you accept the current version."
  },
  "related": {
    "heading": "Related pages",
    "privacy": "Privacy Notice",
    "dataPolicy": "Data Policy",
    "trust": "Trust Center",
    "contact": "Questions about these terms can be sent to"
  }
}
